import React from 'react';
import { IntakeFormData, TIMELINES, BUDGETS } from '../../types/form';

interface Props {
  data: IntakeFormData;
  onChange: (updates: Partial<IntakeFormData>) => void;
}

const inputClass = `
  w-full bg-dark-700 border border-dark-500 rounded-lg px-4 py-3
  text-white text-sm placeholder-gray-600
  focus:outline-none focus:border-lime-400 focus:ring-1 focus:ring-lime-400/20
  transition-all duration-200
`;

const labelClass = "block text-xs font-medium text-gray-300 uppercase tracking-wider mb-2";

const Step4Timeline: React.FC<Props> = ({ data, onChange }) => {
  return (
    <div className="space-y-5 animate-fade-up">
      <div>
        <h2 className="font-display text-2xl font-semibold text-white mb-1">
          Timeline & budget.
        </h2>
        <p className="text-sm text-gray-300">No judgment — this helps us build the right plan for you.</p>
      </div>

      <div>
        <label className={labelClass}>Ideal Timeline *</label>
        <div className="grid grid-cols-1 gap-2">
          {TIMELINES.map(t => (
            <button
              key={t}
              type="button"
              onClick={() => onChange({ timeline: t })}
              className={`
                text-left px-4 py-3 rounded-lg border text-sm font-medium
                transition-all duration-200 flex items-center gap-3
                ${data.timeline === t
                  ? 'border-lime-400 bg-lime-400/10 text-lime-400'
                  : 'border-dark-500 bg-dark-700 text-gray-400 hover:border-dark-400'
                }
              `}
            >
              <span className={`
                w-4 h-4 rounded-full border flex-shrink-0 flex items-center justify-center
                ${data.timeline === t ? 'border-lime-400' : 'border-dark-400'}
              `}>
                {data.timeline === t && (
                  <span className="w-2 h-2 rounded-full bg-lime-400" />
                )}
              </span>
              {t}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className={labelClass}>Budget Range *</label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {BUDGETS.map(b => (
            <button
              key={b}
              type="button"
              onClick={() => onChange({ budget: b })}
              className={`
                px-4 py-3 rounded-lg border text-sm font-medium text-center
                transition-all duration-200
                ${data.budget === b
                  ? 'border-lime-400 bg-lime-400/10 text-lime-400'
                  : 'border-dark-500 bg-dark-700 text-gray-400 hover:border-dark-400'
                }
              `}
            >
              {b}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className={labelClass}>Anything else we should know?</label>
        <textarea
          className={`${inputClass} resize-none`}
          rows={4}
          placeholder="Special requirements, past experiences with agencies, questions, concerns — anything is fair game."
          value={data.additionalNotes}
          onChange={e => onChange({ additionalNotes: e.target.value })}
        />
      </div>

      <div className="bg-dark-700 border border-dark-500 rounded-lg p-4">
        <p className="text-xs text-gray-500 leading-relaxed">
          <span className="text-lime-400 font-medium">What happens next?</span> Once you submit, Edwin and Derek will review your intake within 24 hours and reach out to schedule your kickoff call. We'll come prepared.
        </p>
      </div>
    </div>
  );
};

export default Step4Timeline;
